<template>
  <div>
    <f7-accordion-item class="accordionForm" @accordion:open="openedAccordion=true"
      @accordion:opened="openedFinishedAccordion=true"
      @accordion:close="openedAccordion=openedFinishedAccordion=false" :expanded="open">
      <f7-accordion-toggle 
        class="accordionToggle w-fit-content" 
        v-if="toggleActive"
        :aria-expanded="openedAccordion ? 'true' : 'false'"
        :aria-controls="accordionId"
        role="button"
        :aria-label="title + (openedAccordion ? ' - Réduire' : ' - Développer')">
        <div class="form-group row justify-content-start">
          <div class="col-sm-auto titleAccordion"
            :class="[(isTitleUpperCase ? 'text-uppercase' : ''), (isTitleBold ? 'font-weight-bold' : '')]"
            :id="titleId">
            {{ title }}
            <span v-if="star" class="color-red"> *</span>
            <i class="ml-2 fa-light fa-chevron-down color-var-actionButtonColorBlue"
              v-if="openedAccordion"
              aria-hidden="true">
            </i>
            <i class="ml-2 fa-light fa-chevron-right color-var-actionButtonColorBlue"
              v-if="!openedAccordion"
              aria-hidden="true">
            </i>
          </div>
        </div>
      </f7-accordion-toggle>
      <div class="w-fit-content" v-else>
        <div class="form-group row justify-content-start">
          <div class="col-sm-auto titleAccordion"
               :class="[(isTitleUpperCase ? 'text-uppercase' : ''), (isTitleBold ? 'font-weight-bold' : '')]"
               :id="titleId">
            {{ title }}
          </div>
        </div>
      </div>
      <f7-accordion-content 
        :class="{accordionContentExpended: openedFinishedAccordion}"
        class="pl-3"
        style="border-left: 2px solid #11B0AF;"
        :id="accordionId"
        role="region"
        :aria-labelledby="titleId">
        <slot></slot>
      </f7-accordion-content>
    </f7-accordion-item>
  </div>
</template>

<script>
export default {
  name: 'FormAccordion',
  props: {
    title: {
      type: String
    },
    open: {
      type: Boolean,
      default: true
    },
    star: {
      type: Boolean,
      default: false
    },
    hasDatePicker: {
      type: Boolean,
      default: false
    },
    chevron_open: {
      type: String,
      default: 'chevron_down'
    },
    chevron_close: {
      type: String,
      default: 'chevron_right'
    },
    isTitleUpperCase: {
      type: Boolean,
      default: true
    },

    isTitleBold: {
      type: Boolean,
      default: true
    },
    toggleActive: {
      type: Boolean,
      default: true
    }

  },
  data () {
    return {
      openedAccordion: this.open,
      openedFinishedAccordion: this.open
    }
  },
  computed: {
    accordionId() {
      return 'accordion-' + this._uid
    },
    titleId() {
      return 'accordion-title-' + this._uid
    },
    renderOpenClass () {
      return this.open ? 'accordion-item-expanded' : ''
    }
  },
  watch: {
    open () {
      this.openedAccordion = this.open
    }
  }
}
</script>